export default __webpack_public_path__ + "static/media/Madhupandit.3f780f10.png";